/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1UserUseridDefaultPassword200,
  PostApiV1UserUseridDefaultPassword400,
  PostApiV1UserUseridDefaultPassword401,
  PostApiV1UserUseridDefaultPassword500,
  PostApiV1UserUseridDefaultPasswordMutationRequest,
  PostApiV1UserUseridDefaultPasswordMutationResponse,
  PostApiV1UserUseridDefaultPasswordPathParams,
} from "../../types/userCredenciaisController/PostApiV1UserUseridDefaultPassword.ts";
import { resetDefaultPasswordRequestViewModelSchema } from "../resetDefaultPasswordRequestViewModelSchema.ts";

export const postApiV1UserUseridDefaultPasswordPathParamsSchema = z.object({
  userId: z.coerce.number().int(),
}) as unknown as ToZod<PostApiV1UserUseridDefaultPasswordPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1UserUseridDefaultPassword200Schema =
  z.any() as unknown as ToZod<PostApiV1UserUseridDefaultPassword200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1UserUseridDefaultPassword400Schema =
  z.any() as unknown as ToZod<PostApiV1UserUseridDefaultPassword400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1UserUseridDefaultPassword401Schema =
  z.any() as unknown as ToZod<PostApiV1UserUseridDefaultPassword401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1UserUseridDefaultPassword500Schema =
  z.any() as unknown as ToZod<PostApiV1UserUseridDefaultPassword500>;

export const postApiV1UserUseridDefaultPasswordMutationRequestSchema = z.lazy(
  () => resetDefaultPasswordRequestViewModelSchema,
) as unknown as ToZod<PostApiV1UserUseridDefaultPasswordMutationRequest>;

export const postApiV1UserUseridDefaultPasswordMutationResponseSchema = z.lazy(
  () => postApiV1UserUseridDefaultPassword200Schema,
) as unknown as ToZod<PostApiV1UserUseridDefaultPasswordMutationResponse>;
